import { List, FileText } from 'lucide-react';
import { usePlayer, type ContentView } from '@/context/PlayerContext';
import { cn } from '@/lib/utils';

interface ContentViewTabsProps {
  className?: string;
}

export function ContentViewTabs({ className }: ContentViewTabsProps) {
  const { contentView, setContentView, currentTrack } = usePlayer();

  // Only show tabs when there's a track playing
  if (!currentTrack) {
    return null;
  }

  const tabs: { id: ContentView; label: string; icon: React.ReactNode }[] = [
    { id: 'default', label: 'Inhoud', icon: <List className="w-4 h-4" /> },
    { id: 'lyrics', label: 'Tekst', icon: <FileText className="w-4 h-4" /> },
  ];

  return (
    <div className={cn('flex gap-2 p-2', className)}>
      {tabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => setContentView(tab.id)}
          className={cn(
            'flex items-center gap-2 px-4 py-2 rounded-full font-medium text-sm transition-colors',
            contentView === tab.id
              ? 'bg-text-primary text-bg-base'
              : 'text-text-secondary hover:text-text-primary hover:bg-bg-elevated'
          )}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );
}
